import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appTicketNumberInput]'
})
export class TicketNumberInputDirective
{

    private element: HTMLInputElement;

    constructor(private elRef: ElementRef,
        private renderer: Renderer2)
    {
        // elRef will get a reference to the element where
        // the directive is placed
        this.element = elRef.nativeElement;
    }

    @HostListener('paste', ['$event']) onPaste(e: any)
    {
        // hack for ie11 due to not support pasteevent
        if (!e.clipboardData)
        {
            return;
        }

        <ClipboardEvent>e;

        const pasteVal = e.clipboardData.getData('text');
        const isPasteNumber = /^[0-9]{1,6}$/.test(pasteVal);
        if (!isPasteNumber)
        {
            return false;
        }

        const val = this.element.value;
        const futureVal = val.slice(0, this.element.selectionStart) + pasteVal + val.slice(this.element.selectionEnd);
        if (parseInt(futureVal, 10) > 500000)
        {
            e.preventDefault();
            return false;
        } else
        {
            return true;
        }
    }

    @HostListener('keypress', ['$event']) onKeyPressed(event: KeyboardEvent)
    {
        if (this.numberInputKeyPressed(event) === false)
        {
            event.stopPropagation();
            return false;
        }
    }

    public numberInputKeyPressed(event: KeyboardEvent): boolean
    {
        // allow ctrl + a
        if (event.ctrlKey === true && event.keyCode === 97)
        {
            return true;
        }

        // allow ctrl + x
        if (event.ctrlKey === true && event.keyCode === 120)
        {
            return true;
        }

        // evaluate 
        const isNumber = /^[0-9]{1,6}$/.test(event.key);
        if (!isNumber)
        {
            return false;
        }

        // consume . key
        if (event.keyCode === 46)
        {
            return false;
        }

        const val = this.element.value;
        const futureVal = val.slice(0, this.element.selectionStart) + event.key + val.slice(this.element.selectionEnd);
        if (parseInt(futureVal, 10) > 500000)
        {
            return false;
        } else
        {
            // default return
            return true;
        }
    }
}
